var map = {
	"./backtesting-smart-alerts.ts": 1234,
	"./build-a-smart-alert-step-by-step.ts": 1378,
	"./expected-goals-xg-explained.ts": 2336,
	"./first-half-goals-analysis.ts": 2764,
	"./how-we-measure-prediction-accuracy.ts": 896,
	"./in-play-corner-tactics.ts": 8106,
	"./lead-over-fav-team-events.ts": 4226,
	"./live-match-tracking-guide.ts": 5071,
	"./navigating-live-match-data-overload.ts": 5807,
	"./over-under-match-strategy.ts": 9071,
	"./past-matches-stats-analysis.ts": 3344,
	"./personalized-football-analytics-platform.ts": 823,
	"./pre-match-alerts-guide.ts": 522,
	"./quantifying-match-pressure.ts": 3163,
	"./reading-correct-score-heat-map.ts": 9390,
	"./share-conditions-smart-alerts.ts": 5058,
	"./smart-alerts-personalized-football-notifications.ts": 3753,
	"./smart_alert_templates_hat.ts": 4648,
	"./using-filters-effectively.ts": 9511,
	"./whats-new-2-6-0.ts": 9123,
	"./whats-new-live-predictions-and-guru-summary.ts": 7815,
	"./whats-new-pre-match-alerts-and-track-record.ts": 4390,
	"./xgot-expected-goals-on-target-explained.ts": 9109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9173;